import { render, staticRenderFns } from "./groupingAdd.vue?vue&type=template&id=244a5814&"
import script from "./groupingAdd.vue?vue&type=script&lang=js&"
export * from "./groupingAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports